import * as Immutable from 'immutable'
import orderCaptureService from '../../../services/order-capture-service'
import {LOAD_WALK_IN_INTEREST_FORM} from '../../WalkInInterests/modules/walkInInterests'
// ------------------------------------
// Constants
// ------------------------------------
export const LOAD_ORDER_CAPTURE_BY_REFS = 'LOAD_ORDER_CAPTURE_BY_REFS'
export const LOAD_ORDER_CAPTURE_DYNAMIC_FORM = 'LOAD_ORDER_CAPTURE_DYNAMIC_FORM'

export function loadOrderCaptureByRefs (refs) {
  return (dispatch, getState) => {
    return orderCaptureService.getOrderCaptureByRefs(refs).then((orderCapture) => {
      dispatch({
        type: LOAD_ORDER_CAPTURE_BY_REFS,
        orderCaptures: orderCapture
      })
    })
  }
}

export function loaOrderCaptureForm () {
  return (dispatch, getState) => {
    return orderCaptureService.getOrderCaptureForm()
      .then(function (orderCaptureForm) {
        dispatch({
          type: LOAD_ORDER_CAPTURE_DYNAMIC_FORM,
          orderCaptureForm: orderCaptureForm
        })
      })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

let defaultState = Immutable.fromJS([])

export function loadOrderCaptureByRefsReducer (state = defaultState, action) {
  switch (action.type) {
    case LOAD_ORDER_CAPTURE_BY_REFS: {
      return Immutable.fromJS(action.orderCaptures)
    }
    default:
      return state
  }
}

let defaultOrderCaptureForm = {}

export function orderCaptureFormReducer (state = defaultOrderCaptureForm, action) {
  switch (action.type) {
    case LOAD_ORDER_CAPTURE_DYNAMIC_FORM: {
      return action.orderCaptureForm
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/OrderCapturePrint/modules/OrderCapturePrint.js